import { render, staticRenderFns } from "./TFEquip.vue?vue&type=template&id=63976f9d"
import script from "./TFEquip.vue?vue&type=script&lang=js"
export * from "./TFEquip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports